var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28571 0C9.75722 0 12.5714 2.81421 12.5714 6.28571C12.5714 7.81576 12.0248 9.21812 11.1161 10.3081L15.8326 15.0245C16.0558 15.2477 16.0558 15.6095 15.8326 15.8326C15.6343 16.031 15.3264 16.053 15.1037 15.8988L15.0245 15.8326L10.3081 11.1161C9.21812 12.0248 7.81576 12.5714 6.28571 12.5714C2.81421 12.5714 0 9.75722 0 6.28571C0 2.81421 2.81421 0 6.28571 0ZM6.28571 1.14286C3.44539 1.14286 1.14286 3.44539 1.14286 6.28571C1.14286 9.12604 3.44539 11.4286 6.28571 11.4286C9.12604 11.4286 11.4286 9.12604 11.4286 6.28571C11.4286 3.44539 9.12604 1.14286 6.28571 1.14286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNewIcon);
export default __webpack_public_path__ + "static/media/search-new-icon.017a21898f6460dca3506ee4cd05bd5b.svg";
export { ForwardRef as ReactComponent };